import defaultConfig from '.';

export default {
  ...defaultConfig,
  loadGDPRScript: true,
  pageOpts: {
    ...defaultConfig.pageOpts,
    member: 9700,
    keywords: {
      'no-sno-publishergroup': 'schibsted',
    },
  },
};
